import { Sparkles } from 'lucide-react';
import { Tooltip } from '@/components/ui';

/*
  AIFab — объёмная кнопка ИИ справа снизу, слой z-fab (R12). Фиолетовый — ИИ (R10): заливка bg-ai,
  объём — shadow-ai (блик сверху, глубина снизу, свечение). Наведение — подъём масштабом
  (transition-interactive), значок поворачивается. Своей коралловой точки нет: живое коралловое ядро
  на экране одно (R41) — в знаке главного меню.
*/

export function AIFab({ onOpen }: { onOpen: () => void }) {
  return (
    <Tooltip content="AI Spotlight · ⌘J" side="left">
      <button
        type="button"
        onClick={onOpen}
        aria-label="Открыть AI Spotlight"
        data-floating-fab
        className="group/fab fixed right-6 bottom-6 z-fab grid size-14 place-items-center rounded-full bg-ai text-on-ai shadow-ai transition-interactive hover:scale-110 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-frame focus-visible:outline-none active:scale-95"
      >
        <Sparkles
          size={24}
          strokeWidth={1.75}
          className="transition-transform duration-smooth group-hover/fab:rotate-12"
        />
      </button>
    </Tooltip>
  );
}
